import React, { createRef, useEffect, useState } from 'react'
import { get, post } from '../../util/request';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/action/auth.action';

const Profile = () => {
  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    tasksList: '',
    profile: '',
    form: {
      employee_id: '',
      company_id: '',
    },
    avatar: '',
    fileAvatar: '',
    attendanceSummary: '',
    loading: true
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const urlImageRef = createRef()

  const handleLogout = () => {
    dispatch(logout())
    navigate('/')
  }

  const handleChangeImage = (e) => {
    setState(prevState => {
      return {
        ...prevState,
        avatar: URL.createObjectURL(e.target.files[0]),
        fileAvatar: e.target.files[0]
      }
    })
    // const reader = new FileReader();
    // reader.addEventListener("load", () => {
    //   setState(prevState => {
    //     return {
    //       ...prevState,
    //       fileAvatar: reader.result
    //     }
    //   })
    // });
    // reader.readAsDataURL(e.target.files[0]);
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {

      getProfile()
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getProfile = () => {
    get(
      `public/api/v1/member/me`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            profile: success.data.Data,
            form: {
              company_id: success.data.Data.company_id,
              employee_id: success.data.Data.employee_id,
            },
            avatar: success.data.Data.profile?.employee_avatar,
            loading: false
          }
        })
        getAttendanceSummary(success.data.Data.company_id, success.data.Data.employee_id)
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const getAttendanceSummary = (company_id, employee_id) => {
    post(
      `public/api/v1/member/attendance/summary`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      {
        company_id: company_id,
        employee_id: employee_id
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            attendanceSummary: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const UpdateAvatar = () => {
    const formData = new FormData();
    formData.append("file", state.fileAvatar);

    post(
      `public/api/v1/member/update_my_avatar`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'multipart/form-data'
        },
      },
      {
        company_id: state.form.company_id,
        employee_id: state.form.employee_id,
        image: state.fileAvatar
      },
      success => {
        setShowModal(false)
        window.location.reload();

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  return (
    <div className='w-full h-screen grid-cols-1 bg-white sm:grid-cols-2'>
      <div className='w-full h-20 bg-white'>
        <div className='flex items-center justify-between h-full px-4 pt-8'>
          <div className='flex items-center'>
            <a href={process.env.PUBLIC_URL + "/home"}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4 font-semibold'>Profile</p>
          </div>
          <div className='flex' onClick={handleLogout}>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/off.svg"} className='justify-start p-1' />
            Logout</div>
        </div>
      </div>
      <div className='absolute bottom-0 w-full bg-real-white rounded-t-3xl h-4/5'> </div>
      <div className='absolute bottom-0 w-full top-24'>
        <div className='relative flex justify-around p-4 rounded-3xl '>
          <a href={process.env.PUBLIC_URL + "/profile/edit"} className='absolute w-8 h-8 rounded-full top-8 right-16 bg-real-white'>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/edit.svg"} className='justify-start w-4 py-2 mx-auto' />
          </a>

          <div className='items-center w-4/5'>
            <div className='h-full text-center bg-local rounded-xl bg-gradient-to-b from-red-light-bg to-orange-bg text-real-white'>
              <img alt='logo_home' src={state.profile.profile?.employee_avatar} className='justify-start w-16 py-1 pt-4 mx-auto' />
              <p className='px-2 my-2 text-xs' onClick={() => setShowModal(true)} >Change Photo</p>
              <p className='px-2 my-2 font-semibold text-md'>{state.profile.employee_fullname}</p>
              <p className='px-2 my-2 text-md'>{state.profile.departement?.departement_title}</p>
              <p className='w-2/3 py-2 mx-auto my-2 text-xs text-black bg-white border border-black border-dashed '>NIP {state.profile.employee_nik}</p>
              <div className='flex justify-center px-4 py-2 mx-auto my-4 text-black bg-white rounded-full text-md w-fit'>
                <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/whatsapp.svg"} className='w-4 m-1' />WhatsApp</div>

            </div>
          </div>

        </div>
        <div className='bottom-0 flex justify-center w-full px-4 mt-4 bg-local rounded-3xl'>
          <a href={process.env.PUBLIC_URL + "/profile/detail-absen"} className='flex justify-between w-full h-full p-4 text-center bg-real-white shadow-all rounded-xl'>
            <p className='text-md'> Detail Kehadiran Izin atau sakit </p>
            <p className='text-xl font-semibold'>{">"}</p>
          </a>
        </div>

        <div className='bottom-0 flex justify-center w-full px-4 mt-4 bg-local rounded-3xl'>
        <a href={process.env.PUBLIC_URL + "/profile/laporan-kerja"} className='flex justify-between w-full h-full p-4 text-center bg-real-white shadow-all rounded-xl'>
            <p className='text-md'> Detail Laporan Kerja </p>
            <p className='text-xl font-semibold'>{">"}</p>
          </a>
        </div>

        <div className='bottom-0 flex justify-center w-full px-4 mt-4 bg-local rounded-3xl'>
        <a href={process.env.PUBLIC_URL + "/profile/detail-absen"} className='flex justify-between w-full h-full p-4 text-center bg-real-white shadow-all rounded-xl'>
            <p className='text-md'> History Absensi </p>
            <p className='text-xl font-semibold'>{">"}</p>
          </a>
        </div>

        <div className='bottom-0 flex justify-center w-full px-4 mt-4 bg-local rounded-3xl'>
          <div className='flex justify-between w-full h-full py-4 text-center border-b-2 border-gray-200'>
            <p className='text-md'> Perihal kehadiran </p>
            <p className='font-semibold text-green-500 text-md'>{state.attendanceSummary.attendance_percentage} ({state.attendanceSummary.attendance_percentage_text})</p>
          </div>
        </div>

        <div className='bottom-0 flex justify-center w-full px-4 mt-4 bg-local rounded-3xl'>
          <div className='flex justify-between w-full h-full py-4 border-b-2 border-gray-200'>
            <p className='text-md'> Total keseluruhan Permintaan izin, sakit,dll </p>
            <p className='p-4 px-6 mx-2 font-bold bg-gray-100 rounded-lg'>{state.attendanceSummary.total_attendance_absence}</p>
          </div>
        </div>

        <div className='bottom-0 flex items-center justify-between w-full px-4 mt-4 text-center bg-local justify-self-center rounded-3xl'>
          <div className='grid w-1/3 justify-self-center'>
            <p className='pb-4 text-md'> Perihal Absen </p>
            <p className='p-4 px-6 mx-auto font-bold bg-gray-100 rounded-lg justify-self-center'>{state.attendanceSummary.count_attendance_absence}</p>
          </div>
          <div className='grid w-1/3 justify-self-center'>
            <p className='pb-4 text-md'> Perihal Izin </p>
            <p className='p-4 px-6 mx-auto font-bold bg-gray-100 rounded-lg'>{state.attendanceSummary.count_attendance_permit}</p>
          </div>
          <div className='grid w-1/3 justify-self-center'>
            <p className='pb-4 text-md'> Perihal Sakit </p>
            <p className='p-4 px-6 mx-auto font-bold bg-gray-100 rounded-lg'>{state.attendanceSummary.count_attendance_sick}</p>
          </div>
        </div>
        <>
          {showModal ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-auto max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                      <h3 className="text-3xl font-semibold">
                        Modal Title
                      </h3>
                      <button
                        className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                        onClick={() => setShowModal(false)}
                      >
                        <span className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                          ×
                        </span>
                      </button>
                    </div>
                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      <img alt='logo_home' src={state.avatar} className='justify-start w-16 py-1 pt-4 mx-auto' />
                      <div>
                        <label htmlFor="files" className="btn">Select Image</label>
                        <input id="files" type="file" onChange={(e) => handleChangeImage(e)} ref={urlImageRef}/>
                      </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold text-red-500 uppercase transition-all duration-150 ease-linear outline-none background-transparent focus:outline-none"
                        type="button"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </button>
                      <button
                        className="px-6 py-3 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded shadow outline-none bg-emerald-500 active:bg-emerald-600 hover:shadow-lg focus:outline-none"
                        type="button"
                        onClick={() => UpdateAvatar()}
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}
        </>

      </div>
    </div >
  )
}

export default Profile